type IconProps = {
  className?: string;
};

/**
 * Half-wireframe globe with circuit traces ending in nodes.
 * Draws in the current text colour so it always matches its surroundings.
 */
const DigitalGlobeCircuitIcon = ({ className = "" }: IconProps) => (
  <svg
    viewBox="0 0 64 64"
    fill="none"
    stroke="currentColor"
    strokeWidth={4}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    {/* Globe half: outer edge, meridians and parallels */}
    <path d="M32 8a24 24 0 0 0 0 48" />
    <path d="M32 8a16 24 0 0 0 0 48" />
    <path d="M32 8a8 24 0 0 0 0 48" />
    <path d="M11.2 20H32" />
    <path d="M8 32h24" />
    <path d="M11.2 44H32" />

    {/* Spine the traces branch from */}
    <path d="M32 6v52" strokeWidth={5} />

    {/* Circuit traces */}
    <path d="M32 12h19" />
    <path d="M32 22h11" />
    <path d="M32 32h23" />
    <path d="M32 42h11" />
    <path d="M32 52h19" />

    {/* Nodes */}
    <g fill="currentColor" stroke="none">
      <circle cx="54" cy="12" r="3.4" />
      <circle cx="46" cy="22" r="3.4" />
      <circle cx="58" cy="32" r="3.4" />
      <circle cx="46" cy="42" r="3.4" />
      <circle cx="54" cy="52" r="3.4" />
    </g>
  </svg>
);

export default DigitalGlobeCircuitIcon;
